// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import globalFunc from './global/function.js'
import globalAttr from './global/attribute.js'
// import axios from 'axios'
import api from './axios/api.js'
// import ElementUI from 'element-ui'
import md5 from 'js-md5'
import 'element-ui/lib/theme-chalk/index.css'
// import uploader from 'vue-simple-uploader'
import 'babel-polyfill'
import gallery from 'img-vuer'
import { Button, Select, Pagination, Dialog, Loading, MessageBox, Message, DatePicker, Form, FormItem, Input, Table, Option, Alert } from 'element-ui'

Vue.use(Button)
Vue.use(Select)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Loading)
// Vue.use(MessageBox)
// Vue.use(Message)
Vue.use(DatePicker)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Table)
Vue.use(Option)
Vue.use(Alert)

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$message = Message

Vue.use(globalFunc)
// Vue.use(ElementUI)
// Vue.use(uploader)
Vue.use(gallery)

Vue.config.productionTip = false
// Vue.prototype.$http = axios
Vue.prototype.api = api
Vue.prototype.$md5 = md5
Vue.prototype.globalAttr = globalAttr

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js